import { Controller } from "@hotwired/stimulus"
import { ShowHide } from "./concerns/showHide";

export default class extends Controller {
  static targets = [ "button" ]

  initialize() {
    ShowHide(this)
  }

  connect(){
    this.toggleCallToAction()
  }

  /* Oculto el CTA si ya se ven en pantalla los botones de pago */
  toggleCallToAction(){
    if(this.saleButtonsAreVisible()){
      this.hideAll(this.buttonTargets);
    } else {
      this.showAll(this.buttonTargets);
    }
  }

  saleButtonsAreVisible(){
    var el = document.querySelector("#ticket-sale-container")
    var bounding = el.getBoundingClientRect()

    return bounding.top <= ((window.innerHeight || document.documentElement.clientHeight) - 100)
  }

}
